import { z } from 'zod'

/**
 * Runtime environment, validated at module load.
 *
 * Vite inlines `import.meta.env` at build time, so a missing variable would
 * otherwise surface as `undefined` deep inside a request. Failing here instead
 * turns a silent 404 against `undefined/api/v1/...` into an explicit boot error.
 */
const envSchema = z.object({
  VITE_ADMIN_API_URL: z.url({ error: 'VITE_ADMIN_API_URL must be a valid URL' }),
})

const parsed = envSchema.safeParse(import.meta.env)

if (!parsed.success) {
  const issues = parsed.error.issues.map((i) => `  ${i.path.join('.')}: ${i.message}`).join('\n')
  throw new Error(`Invalid environment configuration:\n${issues}`)
}

export const env = {
  adminApiUrl: parsed.data.VITE_ADMIN_API_URL.replace(/\/$/, ''),
  isDev: import.meta.env.DEV,
} as const
